// src/components/LayoutContent.tsx
"use client";

import { SignedIn, SignedOut, RedirectToSignIn } from "@clerk/nextjs";
import { usePathname } from "next/navigation";
import AppShell from "@/components/AppShell";
import AppTopBar from "@/components/AppTopBar";
import PublicTopBar from "@/components/PublicTopBar";

export default function LayoutContent({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const isDemo = pathname?.startsWith("/demo");
  const isPublic =
    pathname?.startsWith("/people") ||
    pathname?.startsWith("/practice") ||
    pathname?.startsWith("/discoveries/") ||
    pathname?.startsWith("/survey") ||
    pathname?.startsWith("/welcome") ||
    // 2026-10-20・使い方20選の公開用目次ページ。完全一致のみ（下の階層は公開しない）。
    // middleware.ts の公開ルートに加え、こちらにも入れないとログアウトの人が
    // RedirectToSignIn でサインイン画面へ飛ばされる。
    pathname === "/personal";

  // ✅ demo配下は Clerk/アプリ殻を完全に外す（Hydration #418回避）
  if (isDemo) return <>{children}</>;

  // ✅ 公開ページ（/people, /practice等）: 認証シェルなし、セッション非依存
  // AppTopBar は未ログインでも動作する（UserButton が Clerk context を使うため）
  if (isPublic) {
    return (
      <>
        {/* 2026-10-20・/personal（メールのリンク先）は、ログインが要るページへの案内を出さない
            最小の帯（ロゴ＋ログイン）にする。他の公開ページは従来どおり。 */}
        {pathname === "/personal" ? <PublicTopBar /> : <AppTopBar />}
        {children}
      </>
    );
  }

  // ✅ 通常時のみ AppShell + Clerk ガード
  return (
    <>
      <SignedIn>
        <AppTopBar />
        <AppShell hideSidebar={!(pathname === "/" || pathname?.startsWith("/record"))}>
         {children}
       </AppShell>
      </SignedIn>
      <SignedOut>
        <RedirectToSignIn />
      </SignedOut>
    </>
  );
}
